/**
 * Permissions policy for an iframe: each key is a feature name (e.g. geolocation, camera)
 * and the value is the list of domains/origins to allow for that feature (used as-is).
 */
export type IframePermissions = Record<string, string[]>;

/**
 * Applies a permissions policy to an iframe via its `allow` attribute.
 * @param iframeEl - The iframe element
 * @param permissions - Map of feature names to allowed domains/origins (values are used as-is)
 */
export const setPermissions = (
  iframeEl: HTMLIFrameElement,
  permissions: IframePermissions,
): void => {
  if (!permissions) {
    iframeEl.removeAttribute('allow');
    return;
  }
  const parts = Object.entries(permissions).map(([feature, domains]) => {
    const list = domains.join(' ');
    return list ? `${feature} ${list}` : feature;
  });
  const allowValue = parts.join('; ');
  if (allowValue) {
    iframeEl.setAttribute('allow', allowValue);
  }
};
